import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Button, Link } from '@material-ui/core';
import {NavLink} from 'react-router-dom';

const overrideStyle = makeStyles((theme) => ({
    root: {
        textTransform: 'none',
        borderRadius: 8,
        padding: 10,
        boxSizing: 'border-box',
        height: 40,
        backgroundColor: "transparent",
        color: theme.palette.text.secondary,
        textAlign: 'left',
        transitionDuration: '150ms',
        '& .MuiButton-label':
        {
            justifyContent: 'initial',
            paddingLeft: 12
        },

        '& .MuiSvgIcon-root': {
            color: theme.palette.text.primary,
            marginRight: 12,
            fontSize: 20,
            verticalAlign: 'text-bottom',
            marginTop: 'auto',
            marginBottom: 'auto'
        },
    },
    active: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
        '&:hover':
        {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.secondary.main
        },
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main,
        },
    }
}), {name: "RaymanNavButton"});

function NavButton({icon, expanded, label, ...props})
{
    const classes = overrideStyle();
    let conditionalProps = {};
    if(props.to) conditionalProps.activeClassName = classes.active;

    return <Button
    disableRipple
    fullWidth
    disableElevation
    variant="contained"
    component={ props.to ? NavLink : (props.onClick ? <button/> : Link) }
    {...conditionalProps}
    {...props}
    className={classes.root}        
    >
        { icon }
        <span>{label}</span>
    </Button>
}

export default NavButton;